// Generated by scripts/login_captcha/emit.mjs; edit the TypeScript source.
// LUNA only: exact API origins, using the existing API URL override priority.
export const LUNA_CAPTCHA = Object.freeze({
    apiOrigins: ['https://api.luna-00.com', 'https://api.luna-03.com'],
    scriptUrl: 'https://5f7b7a6b1492.edge.sdk.awswaf.com/5f7b7a6b1492/challenge.js',
});
export const LOCAL_PROOF_TTL_MS = 240000;
export function resolveCaptchaConfig(apiUrl, profile = LUNA_CAPTCHA) {
    let origin;
    try {
        origin = new URL(apiUrl || '').origin;
    }
    catch {
        return { mode: 'disabled' };
    }
    if (!profile.apiOrigins.includes(origin))
        return { mode: 'disabled' };
    if (!/^https:\/\/[a-z0-9]+\.edge\.sdk\.awswaf\.com\/[a-z0-9]+\/challenge\.js$/.test(profile.scriptUrl)) {
        return { mode: 'unavailable' };
    }
    return { mode: 'required', scriptUrl: profile.scriptUrl };
}
export const getLoginCaptchaConfig = () => resolveCaptchaConfig(process.env.REACT_APP_USER_API_URL || process.env.REACT_APP_BACK_URL || process.env.REACT_APP_BACKEND_URL);
export function asCaptchaToken(token) {
    return typeof token === 'string' && token.length > 0 && token.length <= 16384 && !/[\r\n]/.test(token)
        ? token : null;
}
export function loginCaptchaHeaders(config, token) {
    if (config.mode === 'disabled')
        return {};
    const proof = asCaptchaToken(token);
    return config.mode === 'required' && proof ? { 'x-aws-waf-token': proof } : null;
}
